import React from "react";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { headerType } from "../../widgets/table";

export const generateExcel = async (
  headers: headerType[],
  data: Record<string, any>[],
  fileName?: string
) => {
  const filename = fileName || "export";

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sheet1");

  // ---- ONLY REMOVE ID IF FIRST COLUMN LABEL IS "ID" ----
  const hasID = headers.length > 0 && headers[0].label === "ID";

  const filteredHeaders = hasID ? headers.slice(1) : headers;

  // Prepare header row
  const colHeaders: string[] = [];
  filteredHeaders.forEach((header, index) => {
    colHeaders.push(header.label);

    let alignment: Partial<ExcelJS.Alignment> = { horizontal: "left" };

    if (header.exlStyle?.alignment?.horizontal) {
      alignment = {
        horizontal: header.exlStyle.alignment.horizontal,
      };
    } else if (["Amount", "Total", "Yardage"].includes(header.label)) {
      alignment = { horizontal: "right" };
    }

    worksheet.getColumn(index + 1).width = header.exlStyle?.width || 15;
    worksheet.getColumn(index + 1).alignment = alignment;
  });

  // Add header row
  worksheet.addRow(colHeaders);

  // ---- REMOVE ONLY FIRST VALUE WHEN ID EXISTS ----
  data.forEach((row: Record<string, any>) => {
    const rowValues = hasID ? Object.values(row).slice(1) : Object.values(row);
    worksheet.addRow(rowValues);
  });

  worksheet.getRow(1).font = { bold: true };

  const buf = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buf]), `${filename}.xlsx`);
};
